__turbopack_context__.v({
  "cardWrapper": "login-modal-module__Drephq__cardWrapper",
  "codeInput": "login-modal-module__Drephq__codeInput",
  "controls": "login-modal-module__Drephq__controls",
  "description": "login-modal-module__Drephq__description",
  "divider": "login-modal-module__Drephq__divider",
  "getCode": "login-modal-module__Drephq__getCode",
  "getCodeButton": "login-modal-module__Drephq__getCodeButton",
  "header": "login-modal-module__Drephq__header",
  "loginButton": "login-modal-module__Drephq__loginButton",
  "loginModalContent": "login-modal-module__Drephq__loginModalContent",
  "main": "login-modal-module__Drephq__main",
  "phoneInput": "login-modal-module__Drephq__phoneInput",
  "phoneTitle": "login-modal-module__Drephq__phoneTitle",
  "scam": "login-modal-module__Drephq__scam",
  "uline": "login-modal-module__Drephq__uline",
  "unactive": "login-modal-module__Drephq__unactive",
});
